/** Job types whose Completion Summary must match PM Machine Assessment (incl. pulley cover). */
export const PULLEY_COVER_REQUIRED_CALL_TYPES = new Set([
  "BREAKDOWN",
  "MAINTENANCE REQUEST",
  "NOISE COMPLAINT",
  "PREVENTATIVE MAINTENANCE",
  "PREVENTIVE MAINTENANCE",
  "MACHINE INSTALLATION",
  "MACHINE REPLACEMENT",
  "MACHINE RELOCATION",
]);

export function requiresPulleyCoverForJobType(serviceCallType) {
  if (!serviceCallType) return false;
  return PULLEY_COVER_REQUIRED_CALL_TYPES.has(String(serviceCallType).toUpperCase());
}

export function hasPulleyCoverPhoto(assessment) {
  const photo = assessment?.pulley_cover_photo;
  if (!photo || photo === "error uploading image") return false;
  if (typeof photo === "object" && (photo.path || photo.uploaded)) return true;
  return false;
}

export function validatePulleyCover(assessment, machineSerial) {
  if (!assessment?.pulley_cover_checked) {
    return `Machine ${machineSerial}: please confirm Pulley Cover Checked`;
  }
  if (!hasPulleyCoverPhoto(assessment)) {
    return `Machine ${machineSerial}: please upload a Pulley Cover photo`;
  }
  return null;
}
